import NextImage from 'next/image';
import styled from 'styled-components';
import { PillBase, LearnMoreBase, AddToCartBase } from '../../styles';
import { mqLargeMin, mqXLargeMin } from 'styled/tools/media-queries';

// FEATURED PRODUCT
export const Container = styled.div`
  border-radius: var(--spacing-32);
  background: var(--fill-brand-subtle);
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: var(--spacing-16);
  padding-bottom: 132px;
  position: relative;

  @media ${mqLargeMin} {
    flex-direction: row;
    margin-right: 16px;
    width: 100%;
    max-width: 900px;
    min-width: 662px; // Last point before the text breaks
    padding-bottom: 0px;
  }

  @media ${mqXLargeMin} {
    max-width: 1050px;
  }
`;
export const Pill = styled(PillBase)`
  background: #d3fa99;
  color: var(--fill-brand);
  position: absolute;
  top: 0;
  margin-top: var(--spacing-16);
`;
export const FeaturedImage = styled(NextImage)`
  position: relative !important; // styled values take backseat to intrinsic next js values
  height: 320px !important;
  object-fit: contain;
  margin-top: var(--spacing-32);

  @media ${mqLargeMin} {
    max-width: 350px;
  }
  @media ${mqXLargeMin} {
    margin-top: var(--spacing-48);
    max-width: 400px;
  }
`;
export const Body = styled.div`
  color: var(--fill-primary);
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
export const InnerText = styled.div`
  display: flex;
  color: inherit;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-24);
`;
export const CodePill = styled.div`
  border-radius: 576.652px;
  border: 1.73px solid var(--fill-primary);
  width: fit-content;
  padding: 0 8px;
  color: inherit;
  margin-bottom: var(--spacing-8);
`;
export const Name = styled.div`
  color: inherit;
  font-size: 24px;
  font-weight: 350;
  line-height: 120%;
  letter-spacing: -0.64px;

  @media ${mqLargeMin} {
    font-size: 32px;
    line-height: 110%;
    letter-spacing: -0.36px;
  }
`;
export const Desc = styled.div`
  color: inherit;
  font-size: 16px;
  font-weight: 350;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.16px;
`;
const PriceBase = styled.div`
  color: inherit;
  font-size: 20px;
  line-height: 130%; /* 26px */
  letter-spacing: -0.2px;
`;
export const StrikePrice = styled.span`
  color: inherit;
  font-size: inherit;
  text-decoration: line-through;
  margin-left: var(--spacing-8);
`;
export const DesktopPrice = styled(PriceBase)`
  display: none;
  padding-top: 24px;

  @media ${mqLargeMin} {
    display: inline;
  }
`;
export const MobilePrice = styled(PriceBase)`
  @media ${mqLargeMin} {
    display: none;
  }
`;
export const CTA = styled.div`
  color: inherit;
  display: flex;
  align-items: center;
  padding: var(--spacing-24) 0;
  justify-content: space-between;

  @media ${mqLargeMin} {
    justify-content: start;
    padding-top: var(--spacing-24);
    padding-bottom: 0;
  }
`;
export const LearnMore = styled(LearnMoreBase)`
  width: 180px;
  color: var(--fill-brand);
  background: var(--fill-primary);

  @media ${mqLargeMin} {
    width: 200px;
  }
`;
export const AddToCart = styled(AddToCartBase)`
  color: inherit;
`;
